<template>
  <div>
    <div class="loading" v-if="loading" style="margin: 50% 0">
      <van-loading type="circular" color="#999" />
    </div>
    <div v-if="!loading">
      <section>
        <header3
          :back="newData.specialHeaderImage"
          :desc="summaryDisplay"
          :desc-html="keywordHighlightEnabled"
          :title="newData.title"
          :status-label="previewStatusConfig ? previewStatusConfig.label : ''"
          :status-color="previewStatusConfig ? previewStatusConfig.color : ''"
        ></header3>
      </section>
      <section>
        <div class="contents" style="background: #fff">
          <div
            class="list"
            v-for="(item, k) in specialArticlesList"
            :key="item.id || k"
          >
            <div class="title">{{ item.name }}</div>
            <div class="photocentent">
              <news
                :newList="item.articlesList"
                from="topic"
                :topicInfo="specialTopicInfo"
              ></news>
            </div>
          </div>
        </div>
      </section>
      <footer1></footer1>
    </div>

    <div
      v-if="keywordTip.show"
      id="keyword-tip"
      class="keyword-tip"
      :style="{ left: keywordTip.left + 'px', top: keywordTip.top + 'px' }"
    >
      <div class="keyword-tip-title">触发关键字</div>
      <div
        v-for="group in keywordTip.groups"
        :key="group.type"
        class="keyword-tip-item"
      >
        <div class="keyword-tip-label">{{ group.label }}：</div>
        <div class="keyword-tip-list">
          <span
            v-for="(kw, index) in group.keywords"
            :key="group.type + '-' + index"
            class="keyword-tip-tag"
            :style="{ backgroundColor: group.bg, color: group.color }"
          >
            {{ kw }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header3 from "@/components/header3";
import news from "@/components/news";
import footer1 from "@/components/footer";
import {
  getArticleVoById,
  getSpecialCategoriesByArticleId,
  checkContent,
} from "../commJs/articles";
import { wechatShare } from "../commJs/wechat";
import previewWatermarkMixin from "../commJs/previewWatermarkMixin";
import keywordHighlightMixin, {
  htmlToPlainText,
  parseKeywordGroups,
} from "../commJs/keywordHighlightMixin";
import { highlightHtml } from "../commJs/keyword";
import { getArticleStatusConfig } from "../constants";

export default {
  mixins: [previewWatermarkMixin, keywordHighlightMixin],
  data() {
    return {
      loading: true,
      newData: {},
      specialArticlesList: [],
      errorT: "",
      highlightedSummaryHtml: "",
    };
  },
  components: {
    header3,
    footer1,
    news,
  },
  computed: {
    queryKey() {
      const key = this.$route.query.key;
      return typeof key === "string" && key.trim() ? key.trim() : undefined;
    },
    isPreviewMode() {
      return Boolean(this.queryKey);
    },
    previewStatusConfig() {
      if (!this.isPreviewMode) return undefined;
      return getArticleStatusConfig(this.newData && this.newData.status);
    },
    specialTopicInfo() {
      return {
        id: this.$route.params.id,
        title: this.newData.title || "",
      };
    },
    topicSummaryText() {
      return String(this.newData.summary || "").trim();
    },
    summaryDisplay() {
      if (this.keywordHighlightEnabled && this.highlightedSummaryHtml) {
        return this.highlightedSummaryHtml;
      }
      return this.topicSummaryText;
    },
  },
  methods: {
    clearKeywordHighlight() {
      this.resetKeywordTipState();
      this.highlightedSummaryHtml = "";
    },
    /**
     * 预览且 from=wechat 时，仅对专题摘要做关键词检测高亮。
     */
    async applyKeywordHighlightIfNeeded() {
      if (!this.shouldHighlightKeywords) {
        this.clearKeywordHighlight();
        return;
      }

      const summary = this.topicSummaryText;
      if (!summary) {
        this.clearKeywordHighlight();
        return;
      }

      try {
        const payload = await checkContent(htmlToPlainText(summary), "gjms");
        const groups = parseKeywordGroups(payload);
        this.keywordData = groups;
        this.highlightedSummaryHtml = highlightHtml(summary, groups);
        this.keywordHighlightEnabled = true;
      } catch (error) {
        console.error("关键词检测失败:", error);
        this.clearKeywordHighlight();
      }
    },
    async getView(id) {
      try {
        const key = this.queryKey;
        const [articleData, categories] = await Promise.all([
          getArticleVoById(id, key),
          getSpecialCategoriesByArticleId(id, key),
        ]);
        this.newData = articleData || {};
        this.specialArticlesList = Array.isArray(categories) ? categories : [];
        this.loading = false;
        if (this.newData.title) {
          document.title = this.newData.title;
          wechatShare(this.newData.title);
        }
        await this.applyKeywordHighlightIfNeeded();
      } catch (error) {
        this.errorT = "加载专题数据失败";
        this.loading = false;
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  watch: {
    $route() {
      this.clearKeywordHighlight();
      this.id = this.$route.params.id || 0;
      if (!this.id || this.id == 0) {
        this.error = "该文章不存在";
      } else {
        this.loading = true;
        this.getView(this.id);
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id || 0;
    if (!this.id || this.id == 0) {
      this.error = "该文章不存在";
    } else {
      this.getView(this.id);
    }
  },
};
</script>

<style scoped lang="less">
.contents {
  min-height: 60vh;
}

.photocentent {
  padding: 10px;
}

.title {
  padding: 10px;
  font-size: 18px;
  color: #3a60e1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  position: relative;
  padding-left: 20px;
  background: #eee;

  &:after {
    content: "";
    position: absolute;
    height: 15px;
    width: 2px;
    background: #3a60e1;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>

<style lang="less">
.kw-highlight,
span[data-highlight="yes"] {
  display: inline-block;
  line-height: 2;
  cursor: pointer;
  position: relative;
  border-radius: 2px;
}

.keyword-tip {
  position: fixed;
  z-index: 10000;
  padding: 12px;
  max-width: 280px;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
  color: #606266;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  word-break: break-all;
  pointer-events: none;
}

.keyword-tip-title {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #303133;
}

.keyword-tip-label {
  margin-bottom: 4px;
  font-weight: 600;
}

.keyword-tip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.keyword-tip-tag {
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  height: 24px;
  padding: 0 10px;
  line-height: 24px;
}
</style>
